
export default {
  props: {
    adSlot: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      observer: null
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(this.handleIntersection);
    this.observer.observe(this.$refs.googleAdStyle);
  },
  methods: {
    handleIntersection(entries) {
      if (entries[0].isIntersecting) {
        const adScript = document.createElement("script");
        adScript.innerHTML = `(adsbygoogle = window.adsbygoogle || []).push({});`;
        const ins = document.createElement("ins");
        ins.className = "adsbygoogle";
        ins.style.display = "block";
        ins.setAttribute("data-ad-client", "ca-pub-6612490456597819");
        ins.setAttribute("data-ad-slot", this.adSlot);
        ins.setAttribute("data-ad-format", "rectangle");
        ins.setAttribute("data-full-width-responsive", "true");
        this.$refs.googleAdStyle.appendChild(ins);
        this.$refs.googleAdStyle.appendChild(adScript);
        this.observer.unobserve(this.$refs.googleAdStyle);
      }
    }
  }
};
